var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 3.23828V0.894531H6.39844V3.23828H0.375ZM8.10938 3.23828V0.894531H14.1328V3.23828H8.10938Z",
    fill: "#9B9BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDash);
export default __webpack_public_path__ + "static/media/double-dash.16553e1f.svg";
export { ForwardRef as ReactComponent };